import * as React from "react";
import "./style.css";
import ReactSignatureCanvas from "react-signature-canvas";
import CarDamageHandler from "../../../departments/CarDamageHandler";
import { addDamage, getLoanCars, removeDamage } from "../../../../state/department/loanCarActions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../state";
import { RootState } from "../../../../state";
import { getDepartments } from "../../../../state/action";
import { LoanCarDropdown } from "./loanCarDropdown";
import { addStringTimeToDate } from "../../../utils/departmentHelper";
import { convertUSDateToEUWithTimeDate, convertUSDateToEUWithTimeDateShort } from "../../../../util/DateHelper";
import { DefaultButton, Dialog, DialogFooter, DialogType, Icon, PrimaryButton, Spinner } from "@fluentui/react";
import { PDFDocument, PDFPage, rgb } from "pdf-lib";
import api from "../../../../api";
import { updateOrder } from "../../../../state/order/action";

const PDFPATH = "/Låneaftale_Kundebil_El.pdf";

interface Props {
    order: Order;
    signatureDriver?: string;
    signature?: string;
    insuranced: boolean;
    driverLicense: string;
    setInsuranced: (value: boolean) => void;
    setDriverLicense: (value: string) => void;
    onDismiss: () => void;
    onShowSignDial: (value: "DRIVER" | "DISCLIAMER" | undefined) => () => void;
   
}

const SignPdf: React.FunctionComponent<Props> = props => {
    const departments = useSelector((state: RootState) => getDepartments(state));
    const [startDate] = React.useState<Date>(addStringTimeToDate(new Date(props.order.timeAndPlace.date), props.order.timeAndPlace.from ? props.order.timeAndPlace.from : "00:00"));
    const [endDate] = React.useState<Date>(addStringTimeToDate(new Date(props.order.timeAndPlace.date), props.order.timeAndPlace.to ? props.order.timeAndPlace.to : "00:00"));
    const [loanCars, setLoanCars] = React.useState<LoanCar[]>([]);
    const [loanCar, setLoanCar] = React.useState<LoanCar | undefined>();
 
    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>() as any;
    const signatureHeight = 55;
    const { order, insuranced, driverLicense, setDriverLicense, setInsuranced } = props;

    React.useEffect(() => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id) {
            dispatch(getLoanCars(props.order.timeAndPlace.department.id));
        }
    }, [props.order.timeAndPlace.department])

    React.useEffect(() => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id) {
            const department = departments.find(x => order.timeAndPlace.department && x.id === order.timeAndPlace.department.id);
            setLoanCars(department && department.loanCars ? department.loanCars : []);
            setLoanCar(department && department.loanCars && department.loanCars[0]);
        }
    }, [departments, props.order.timeAndPlace.department])
    const onInsuranceClick = (e: React.MouseEvent<HTMLInputElement>) => setInsuranced(e.currentTarget.checked);
    const addDamageClick = (type: "Before" | "After") => (damage: CarDamage) => {

        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id && loanCar) {
            dispatch(addDamage(props.order.timeAndPlace.department.id, loanCar.id, damage));
        }
    };

    // Remove marker when clicked
    const removeDamageClick = (type: "Before" | "After") => (markerId: string) => {
        if (props.order.timeAndPlace.department && props.order.timeAndPlace.department.id && loanCar) {
            dispatch(removeDamage(props.order.timeAndPlace.department.id, loanCar.id, markerId));
        }
    };

    

    const onDriverLicenseChange = (e: React.ChangeEvent<HTMLInputElement>) => setDriverLicense( e.currentTarget.value);

    const onSaveClick = async () => {
        setShowLoader(true);
        const existingPdfBytes = await fetch(PDFPATH).then(res =>
            res.arrayBuffer()
        );

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const secondPage = pages[1];
        const signDate = convertUSDateToEUWithTimeDate(new Date());
        const addsignatureToPage = async (page: PDFPage, signatureDataUrl: string, signDate: string, yOnPage: number) => {

            const signatureImageBytes = await fetch(signatureDataUrl).then(res =>
                res.arrayBuffer()
            );
            const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
            // add signature to the pdf
            page.drawImage(signatureImage, { x: 50, y: yOnPage, width: 200, height: 27.5 });

            page.drawText(signDate, { size: 20, color: rgb(0, 0, 0), x: 350, y: yOnPage });
        }
      
        props.signatureDriver && await addsignatureToPage(firstPage, props.signatureDriver, signDate, 125);
        props.signature && await addsignatureToPage(secondPage, props.signature, signDate, 165);

        firstPage.drawText(convertUSDateToEUWithTimeDateShort(startDate), { size: 12, color: rgb(0, 0, 0), x: 65, y: 551 });
        firstPage.drawText(convertUSDateToEUWithTimeDateShort(endDate), { size: 12, color: rgb(0, 0, 0), x: 190, y: 551 });
        if (loanCar) {
            const scaleValue = 0.775;
            const imageHeight = 123;
            firstPage.drawText(loanCar.regNumber, { size: 11, color: rgb(0, 0, 0), x: 73, y: 596 });
            firstPage.drawText(`${loanCar.make} ${loanCar.model}`, { size: 11, color: rgb(0, 0, 0), x: 197, y: 596 });
            if (loanCar.damage) {
                loanCar.damage.forEach(element => {
                    firstPage.drawCircle({ x: 76 + (element.x) * scaleValue, y: 484 - ((imageHeight - element.y) * scaleValue), size: 8, color: rgb(1, 0, 0) });
                });
                loanCar.damage.filter(x => {
                    let date = new Date(x.date)
                    date.setMinutes(date.getMinutes() + 15);
                    return date < startDate
                }).forEach(element => {
                    firstPage.drawCircle({ x: 340 + (element.x) * scaleValue, y: 484 - ((imageHeight - element.y) * scaleValue), size: 8, color: rgb(1, 0, 0) });
                });
            }
        }
        if (props.order.additionalData.orderNr) {
            firstPage.drawText(props.order.additionalData.orderNr, { size: 12, color: rgb(0, 0, 0), x: 78, y: 657 });
        }
        firstPage.drawText(props.order.customer.name, { size: 12, color: rgb(0, 0, 0), x: 340, y: 708 });
        firstPage.drawText(driverLicense, { size: 12, color: rgb(0, 0, 0), x: 363, y: 681 });

        if (insuranced) {
            firstPage.drawSvgPath("M6.75 12.127L3.622 9l-1.065 1.057L6.75 14.25 15.75 5.25l-1.057-1.058L6.75 12.127z", { color: rgb(0, 0, 0), x: 308, y: 538.5, scale: 0.61 });
        }

        if (props.order.additionalData.orderId && loanCar) {
            const pdfBytes = await pdfDoc.save();
            // pdf-lib returns an ArrayBuffer-backed array, which the Blob typings cannot infer
            const blob = new Blob([pdfBytes as Uint8Array<ArrayBuffer>], { type: "application/pdf" });
            const url = await api.OrderAPI.SignLoanCar(props.order.additionalData.orderId, loanCar.id, blob);
            dispatch(updateOrder({ ...props.order, orderProperties: { ...props.order.orderProperties, signedLoanCar: url, loanCarId: loanCar.id } }));
            if (insuranced) {
                const loanCarInsurance = await api.OrderAPI.createLoanCarInsurance(props.order.additionalData.orderId);
            }
        }
        props.onDismiss();
    }

  

    return (<>
         
        <div className="signature_section">
            <div className="box full_width_box">
                <div>
                    <h3>Dansk Bilglas A/S</h3>
                    <p>Virkelyst 4</p>
                    <p> 9400 Nørresundby</p>
                    <br />

                    <p>Tlf:: 70 11 55 55</p>
                </div>

                <div>
                    <label htmlFor="">Ordrenr.:</label>
                    <input
                        type="text"
                        id="orderNumber"
                        name="orderNumber"
                        defaultValue={order.additionalData.orderNr}
                    />
                </div>
            </div>

            {/* Car and period */}
            <div className="box_wrapper">
                {/* Loan car */}
                <div className="box">
                    <h3>Lånebil</h3>
                    <div className="input_wrapper">
                        <label htmlFor="regNumber">Reg.nr.:</label>
                        <LoanCarDropdown car={loanCar} cars={loanCars} onChange={setLoanCar} ></LoanCarDropdown>
                    </div>

                    <div className="input_wrapper">
                        <label htmlFor="carModel">Model:</label>
                        <input type="text" id="carModel" name="carModel" value={loanCar && `${loanCar.make} ${loanCar.model}`} contentEditable={false} />
                    </div>

                    <div className="input_wrapper">
                        <label htmlFor="fuelType">Drivmiddel:</label>
                        <input type="text" id="fuelType" name="fuelType" value={loanCar && loanCar.fuelType} contentEditable={false} />
                    </div>
                </div>

                {/* Loan period */}
                <div className="box">
                    <h3>Låneperiode</h3>
                    <div className="flex loan_period">
                        <div className="input_wrapper">
                            <label className="startTime" htmlFor="startTime">
                                Start:
                            </label>

                            <input type="text" id="startTime" name="startTime" value={convertUSDateToEUWithTimeDate(startDate)} />
                        </div>

                        <div className="input_wrapper">
                            <label htmlFor="endTime">Slut:</label>
                            <input type="text" id="endTime" name="endTime" value={convertUSDateToEUWithTimeDate(endDate)} />
                        </div>
                    </div>
                    <p className="flex-end-text">Bilen skal afleveres senest kl. 16.00</p>
                </div>
            </div>

            {/* Driver and price */}
            <div className="box_wrapper">
                {/* Driver */}
                <div className="box">
                    <h3>Fører</h3>
                    <div className="input_wrapper">
                        <label htmlFor="">Navn:</label>
                        <input type="text" id="name" name="name" value={order.customer.name} />
                    </div>

                    <div className="input_wrapper">
                        <label htmlFor="">Kørekortnr.:</label>
                        <input onChange={onDriverLicenseChange} value={driverLicense} type="text" id="license" name="license" />
                    </div>
                </div>

                {/* Price */}
                <div className="box">
                    <h3>Pris inkl. moms</h3>

                    <div className="input_wrapper">
                        <label htmlFor="">Pr. dag inkl. 250 km kr.</label>
                        <input
                            readOnly
                            className="input_disabled"
                            type="text"
                            id="price-per-day"
                            name="price-per-day"
                            contentEditable={false}
                            value={"0,00"}
                        />
                    </div>

                    <div className="input_wrapper">
                        <label htmlFor="">Selvrisiko pr. skade kr.</label>
                        <input
                            readOnly
                            className="input_disabled"
                            type="text"
                            id="insurance"
                            name="insurance"
                            contentEditable={false}
                            value={"5.000,00"}
                        />
                    </div>

                    <div className="input_wrapper">
                        <label htmlFor="">
                            Frikøb af selvrisiko pr. dag
                        </label>
                        <input
                            readOnly
                            className="input_disabled"
                            contentEditable={false}
                            type="text"
                            id="insurance-risk"
                            name="insurance-risk"
                            value={"100,00"}
                        />
                    </div>
                    <div className="checkbox_wrapper">
                        <input
                            checked={insuranced}
                       
                            type="checkbox"
                            id="insurance-additional"
                            name="insurance-additional"
                            onClick={onInsuranceClick}
                        />
                        <label htmlFor="insurance-additional">
                            <strong>Tilkøb af selvrisikofraskrivelse</strong>
                        </label>
                    </div>
                </div>
            </div>

            {/* Damage */}
            <div className="box full_width_box">
                <h3>Skader</h3>

                <div className="damage_image_wrapper">
                    <div className="damage_image" >
                        <p>Før udlevering</p>
                        <CarDamageHandler addDamage={addDamageClick("Before")} removeDamage={removeDamageClick("Before")} damage={loanCar && loanCar.damage && loanCar.damage.filter(x => {
                            let date = new Date(x.date)
                            date.setMinutes(date.getMinutes() + 15);
                            return date < startDate
                        })} />
                    </div>

                    <div className="damage_image">
                        <p>Efter udlevering</p>
                        <CarDamageHandler addDamage={addDamageClick("After")} removeDamage={removeDamageClick("After")} damage={loanCar && loanCar.damage} />
                    </div>
                </div>
            </div>

            {/* Regarding electric cars */}            
            <div className="box full_width_box signature_box">
                <div>
                    <div>
                        <p>
                            <b>
                            Gælder for lånebiler på el
                            </b>
                        </p>
                        <p>
                            Bilen er opladet og har strøm til ca. 250 km kørsel. Skal du køre længere, skal du selv sørge for opladning. Har du brug for hjælp til, hvordan du lader bilen op, finder du en vejledning i handskerummet eller via dette link:
                        </p>
                        <p>
                            <a href="https://bilglas.dk/opladning" target="_blank">https://bilglas.dk/opladning</a>
                        </p>
                    </div>
                </div>
            </div>

            {/* Signature Car */}
            <div className="box full_width_box signature_box">
                <div className="text_wrapper">
                    <div>
                        <p>
                            Hvis ikke der er tilkøbt selvrisikofraskrivelse, er der en
                            selvrisiko på kr. 5.000,00 pr. skade (også glasskader).
                            Selvrisikoen vil dog aldrig overstige udgiften til
                            udbedring af skaden.
                        </p>
                        <br />
                        <p>
                            Rygning og husdyr i bilen er forbudt.
                        </p>
                        <br />
                        <p>
                            Bilen kontrolleres for skader af vores montør ved
                            aflevering.
                        </p>
                    </div>

                    <div>
                        <p>
                            Eventuelle bøder herunder standsnings- og
                            parkeringsafgifter mv. i låneperioden betales af føreren.
                        </p>
                        <br />
                        <p>
                            Låneaftalen kan kun forlænges ved ny låneaftale.
                        </p>
                        <br />
                        <p>
                            Bilen må IKKE føres af andre end her benævnte fører.
                        </p>
                        <br />
                        <p>
                            Låneaftalen skal medbringes under kørsel.
                        </p>
                        <br />
                        <p>
                            <b>
                                Bilen skal afleveres i samme stand, som den blev
                                modtaget.
                            </b>
                        </p>
                    </div>
                </div>

                <div className="flex flex-full-width">
                    <div className="signature_wrapper" onClick={props.onShowSignDial("DRIVER")}>
                        <div  className="signature_image_wrapper">
                            {props.signatureDriver &&<img src={props.signatureDriver} />}
                        </div>

                        <label htmlFor="">Fører</label>
                    </div>

                    <div className="signature_wrapper">
                        <input className="signaturDate" style={{ height: signatureHeight }} type="text" id="date" name="date" value={order.timeAndPlace.date} />
                        <label htmlFor="">Dato</label>
                    </div>
                </div>
            </div>

            {/* Signature legal */}
            <div className="box full_width_box signature_box">
                <div>
                    <div>
                        <h3>
                            Tro- og loveerklæring – Kørsel i strid med lov om
                            vanvidskørsel (127)
                        </h3>
                        <p>Ved lån af værkstedsbil.</p>
                        <br />
                        <p>
                            Jeg erklærer på tro og love, at jeg ikke vil køre i
                            bilen på en sådan måde, at kørslen er i strid med
                            lov om vanvidskørsel (L127), hvorfor politiet vil
                            være berettiget til at beslaglægge og herefter
                            konfiskere køretøjet.
                        </p>
                        <br />
                        <p>
                            Ved min underskrift på denne tro- og loveerklæring
                            accepterer jeg at være fuldt erstatningsansvarlig
                            over for ejeren af denne bil, hvis jeg eller den jeg
                            overlader køretøjet til overtræder lov om
                            vanvidskørsel.
                        </p>
                        <br />
                        <p>
                            Jeg anerkender ved min underskrift at være blevet
                            orienteret om risikoen for at blive pålagt at betale
                            en erstatningssum til Dansk Bilglas A/S på det lånte
                            køretøjs værdi i tilfælde af, at køretøjet
                            konfiskeres af politiet, jf. lov om vanvidskørsel.
                        </p>
                        <br />
                        <p>
                            Der gøres opmærksom på, at det fulde erstatningskrav
                            plus renter vil blive inddrevet ved civilt søgsmål,
                            hvis betalingen ikke forfalder rettidigt.
                        </p>
                        <br />
                        <p>
                            Jeg erklærer på tro og love, at jeg ikke tidligere
                            er straffet for vanvidskørsel eller grovere
                            forseelser af færdselsloven, f.eks. gentagne
                            forseelser, forseelser, der har resulteret i
                            frakendelse af kørekortet eller givet fængselsstraf
                        </p>
                        <br />
                        <p>
                            Jeg erklærer på tro og love, at jeg i tilfælde af
                            konfiskation under min varetægt har betalingsevnen
                            til at erstatte det konfiskerede køretøj enten
                            kontant eller ved en løbende afdragsordning
                        </p>

                        <h4>Lov om vanvidskørsel (L127)</h4>
                        <p>Færdselsloven § 117 ff</p>

                        <br />
                        <p>
                            Følgende overtrædelser betragtes som vanvidskørsel:
                        </p>
                        <ul>
                            <li>
                                Uagtsomt manddrab under særligt skærpende
                                omstændigheder.
                            </li>
                            <li>
                                Uagtsomt at forvolde af betydelig skade på
                                nogens legeme eller helbred under særligt
                                skærpende omstændigheder.
                            </li>
                            <li>Særlig hensynsløs kørsel.</li>
                            <li>
                                Kørsel med hastighedsoverskridelse på mere end
                                100 pct. ved kørsel over 100 km i timen.
                            </li>
                            <li>
                                Kørsel med en hastighed på 200 km/timen eller
                                derover.
                            </li>
                            <li>Spirituskørsel med en promille over 2,00.</li>
                        </ul>
                        <p>
                            Du gøres opmærksom på at kap- og væddeløbskørsel er
                            skærpet fra bøde til fængsel. Kap- og
                            væddeløbskørsel vil som udgangspunkt medføre
                            ubetinget frakendelse af førerretten i minimum 3 år
                            efter færdselsloven.
                        </p>
                        <br />
                        <p>
                            Skærpelse af straffen til fængsel for de groveste
                            hastighedsforseelser, dvs. hvor hastigheden er 200
                            km/timen eller derover, eller mere end 100 pct. for
                            hurtigt, hvis hastigheden er mere end 100 km/t.
                        </p>
                        <br />
                        <p>
                            Overtrædelserne vil desuden som udgangspunkt medføre
                            ubetinget frakendelse af førerretten i minimum 3 år.
                        </p>
                        <br />
                        <p>
                            Jeg anerkender ved min underskrift at være blevet
                            orienteret om, at køretøjet er forsynet med en
                            GPS-tracker, som logger bilens lokation og fart.
                        </p>
                    </div>
                </div>

                <div className="flex flex-full-width">
                    <div className="signature_wrapper" onClick={props.onShowSignDial("DISCLIAMER")}>
                        
                        <div className="signature_image_wrapper">
                            {props.signature &&<img src={props.signature} />}
                        </div>

                        <label htmlFor="">Underskrift</label>
                    </div>

                    <div className="signature_wrapper" >
                        <input
                            className="signaturDate"
                            style={{ height: signatureHeight }}
                            type="text"
                            id="signature-legal-date"
                            name="signature-legal-date"
                            value={order.timeAndPlace.date}
                        />
                        <label htmlFor="">Dato</label>
                    </div>
                </div>
            </div>
        </div>
        <DialogFooter>
            {showLoader? <Spinner className="map_loading__spinner" />:<PrimaryButton onClick={onSaveClick} text="OK" />}
            <DefaultButton onClick={props.onDismiss} text="Anuller" />
        </DialogFooter>
    </>
    );
};

export default SignPdf;